import React, {useCallback} from 'react'
import {flowRight} from 'lodash-es'
import qs from 'query-string'

// Components
import RentComponent from './rent.component'

// Constants
import {RENT_PAGE} from '~/constants/pages.constant'

// HOCs
import {withHooks, withLayout} from '~/hocs'

// Util
import {getProductCardSrcSetAndSizes} from '~/utils'

const useHooks = (props) => {
  const {
    navigate,
    data,
    pageContext: {
      limit,
      page,
      pageCount,
      totalCount: count,
    },
  } = props

  const products = data.products.edges.map(({
    node: {
      acf,
      ...restNode
    },
  }) => {
    const {srcSet, sizes} = getProductCardSrcSetAndSizes(acf.thumbnail.url, acf.thumbnail.mediaDetails.width, acf.thumbnail.mediaDetails.height)

    acf.thumbnail.srcSet = srcSet
    acf.thumbnail.sizes = sizes

    return {...acf, ...restNode}
  })

  const hidePrevButton = page > Math.ceil(pageCount)
  const hideNextButton = page >= Math.ceil(pageCount)

  const handlePageChange = useCallback(
    ({selected}) => {
      const pageIndex = selected + 1

      navigate(pageIndex === 1 ? RENT_PAGE : `${RENT_PAGE}/trang-${pageIndex}`)
    },
    [navigate],
  )

  const hrefBuilder = useCallback(
    (pageIndex) => (pageIndex === 1 ? RENT_PAGE : `${RENT_PAGE}/trang-${pageIndex}`),
    [],
  )

  const handleOrderTypeChange = (e) => {
    const orderType = e.target.value
    const queryString = qs.stringify({
      orderType,
      isFor: 'rent',
    })

    navigate(`/search?${queryString}`)
  }

  return {
    productsPerPage: limit,
    page,
    products,
    count,
    pageCount,
    hidePrevButton,
    hideNextButton,
    headTitle: `Thuê nhà TP. Hồ Chí Minh - trang ${page}`,
    mainTitle: (
      <>
        {'Thuê nhà '}
        <span className='green'>TP. Hồ Chí Minh</span>
        {page > 1 && ` - trang ${page}`}
      </>
    ),
    handlePageChange,
    hrefBuilder,
    handleOrderTypeChange,
  }
}

const RentPage = flowRight(
  withHooks(useHooks),
  withLayout({pageName: RENT_PAGE}),
)(RentComponent)

export default RentPage
